/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import TruncateText from '../TruncateText/TruncateText';
import { isTabToolLaunch, formatName } from '../../util/tool';

const truncateContent = (text) => (
  <TruncateText
    button={false}
    tooltipPlacement="right"
    text={text}
    textVariant="body2"
  />
);

const MLToolLaunchLink = (props) => {
  const {
    data,
    testId,
    contentUiScope,
    launchAction,
    linkLabel,
    children,
    dispatch,
    className,
    courseId,
    truncate,
    isLinkDisabled,
    getLaunchUrl,
    handleLocalLaunch,
  } = props;

  const launchUrl =
    typeof getLaunchUrl === 'function'
      ? getLaunchUrl({
          ...data,
          actual_course_id: courseId,
        })
      : undefined;
  const isNewTab = isTabToolLaunch(data.tool);

  let newActivityName;
  if (linkLabel) {
    newActivityName = linkLabel;
  } else {
    const activityName = formatName(data.name, data.tool, data.createdAt);
    newActivityName = activityName;
  }

  const formattedActivityName = truncate
    ? truncateContent(newActivityName)
    : newActivityName;
  if (isLinkDisabled) {
    return formattedActivityName;
  }

  const onClickHandler = (event) => {
    // Optional gradebook-specific functionality - only dispatch if available
    if (dispatch && contentUiScope) {
      // These actions may not exist in dashboards context, so we'll skip them
      // dispatch(setHighlightToItems([data.id], contentUiScope));
      // dispatch(setScrollToItem(true, contentUiScope));
    }

    if (handleLocalLaunch) {
      // Local links use CW's reactor router, need to stop them from <a> behavior
      event.preventDefault();
      const openInNewTab =
        isNewTab || event.ctrlKey || event.shiftKey || event.metaKey;
      handleLocalLaunch(launchUrl, openInNewTab);
    }
  };

  if (launchAction) {
    return (
      <a
        href={launchUrl}
        className={className}
        onClick={launchAction(data.activity_id, data.id)}
        data-test-id={testId}
      >
        {formattedActivityName}
      </a>
    );
  }

  const linkContent = children || formattedActivityName;

  const externalLink = (
    <a
      href={launchUrl}
      className={className}
      target={isNewTab ? '_blank' : '_self'}
      onClick={onClickHandler}
      data-test-id={testId}
      aria-label={
        isNewTab ? `${data.name} Opens in a new windows` : `${data.name}`
      }
      rel="noreferrer"
    >
      {linkContent}
    </a>
  );

  return externalLink;
};

MLToolLaunchLink.propTypes = {
  data: PropTypes.object,
  testId: PropTypes.string,
  contentUiScope: PropTypes.string,
  isTOC: PropTypes.bool,
  launchAction: PropTypes.func,
  linkLabel: PropTypes.string,
  children: PropTypes.node,
  restrictedAccess: PropTypes.bool,
  courseType: PropTypes.string,
  dispatch: PropTypes.func,
  className: PropTypes.string,
  courseId: PropTypes.string,
  cellWidth: PropTypes.number,
  truncate: PropTypes.bool,
  isLinkDisabled: PropTypes.bool,
  getLaunchUrl: PropTypes.func,
  handleLocalLaunch: PropTypes.func,
  isSection: PropTypes.bool,
  isSectionManager: PropTypes.bool,
};

function mapStateToProps(state) {
  // In dashboards, courseId might be stored differently or passed as prop
  const courseId =
    _get(state, 'reports.courseAbstract.id') || _get(state, 'course.id');
  return {
    courseId,
  };
}

export default connect(mapStateToProps)(MLToolLaunchLink);
